import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { MenuAppConfig, WebApp } from "go-app/services/types";
import { StickyNavigationItem } from "go-app/utils/types";
import { ReactComponent as SettingsSVG } from "go-core/images/svg/navigation/settings.svg";
import { withoutNavigationInsideWebview } from "go-core/utils/utils";
import NavigationComponentSecurity from "go-security/components/Navigation";
import { NavigationType } from "go-security/components/Navigation/NavigationType";
import { selectOrganization } from "go-security/services/organizations/selectors";
import { selectIsAdmin, selectUser } from "go-security/services/users/selectors";
import { ConfigContext } from "../../services/Config/context";
import { getApiURL } from "../../utils/envutil";
import NavigationOrganizationMenu from "./components/NavigationOrganizationMenu";
import NavigationUserMenu from "./components/NavigationUserMenu";

const Navigation = (): JSX.Element | null => {
	const { t } = useTranslation("lib");
	const user = useSelector(selectUser);
	const organization = useSelector(selectOrganization);
	const isAdmin = useSelector(selectIsAdmin);
	const configService = useContext(ConfigContext);
	const applications = configService.applications();
	const baseUrl = getApiURL();

	const menuAppConfig: MenuAppConfig = {
		webApp: WebApp.GOPOS,
		userEnteredLocation: organization.company_id !== undefined,
		oldVersionAppsTimestamp: configService.getAppsOldVersionTimestamps(),
	};

	const stickyNavigationItems: StickyNavigationItem[] = [
		{
			name: t("common.word.settings", { ns: "lib" }),
			path: `/${organization.id}/settings`,
			icon: <SettingsSVG />,
			hide: () => !organization.id,
		},
	];

	if (withoutNavigationInsideWebview) return <></>;
	if (window.navigator.userAgent.endsWith("GOPOS_WEBVIEW") && location.pathname.includes("live_orders")) return <></>;

	return (
		<NavigationComponentSecurity
			user={user}
			organization={organization}
			apps={applications}
			logo={"/graphics/gopos-logo.svg"}
			logo_small={"/graphics/apps/gopos.svg"}
			isAdmin={isAdmin}
			baseUrl={baseUrl}
			menuAppConfig={menuAppConfig}
			stickyNavigationItems={stickyNavigationItems}
		>
			<NavigationType
				userNavigation={
					<NavigationUserMenu
						user={user}
						goaccounts_url={configService.getGoAccountsUrl()}
						isAdmin={isAdmin}
					/>
				}
				organizationNavigation={<NavigationOrganizationMenu organization={organization} />}
			/>
		</NavigationComponentSecurity>
	);
};

export default Navigation;
